module.exports = __webpack_public_path__ + "static/media/ChemistTop.f3d9a449.webp";